<template>
  <modal @close="$emit('close')" :close-on-click="false">
    <form class="w-full max-w-md" @submit.prevent="submit">
      <div class="w-full mb-2 px-2">
        <nx-input
          v-model="email"
          :errors="form.errors"
          placeholder="zealot@auir.com"
          id="email"
          type="email"
          label="Email"
          maxlength="255"
          :focus="true"
        />
      </div>

      <div class="w-full mb-4 px-2">
        <nx-input
          v-model="password"
          :errors="form.errors"
          id="password"
          type="password"
          label="Password"
          maxlength="30"
        />
      </div>

      <div class="w-full mb-4 px-2 | recaptcha">
        <captcha @response="catpchaResponse" :errors="form.errors" id="recaptcha" ref="recaptcha"></captcha>
      </div>

      <div class="w-full text-center">
        <nx-button
          type="secondary"
          native-type="submit"
          :disabled="loading"
        >{{ loading ? 'Loading..' : 'Login' }}</nx-button>
      </div>
    </form>

    <div class="w-full text-center mt-4">
      <a
        @click="forgotPassword"
        class="text-blue-7 hover:text-blue-8 cursor-pointer"
      >Forgot your Password?</a>
    </div>
  </modal>
</template>

<script>
import Form from "form-backend-validation"
import { EventBus } from "@/events"

export default {
  name: "LoginForm",
  data() {
    return {
      form: new Form(),
      email: "",
      password: "",
      recaptcha: "",
      loading: false
    }
  },
  methods: {
    async submit() {
      this.loading = true
      this.form.errors.clear()
      await this.$auth.login({
        data: { email: this.email, password: this.password, recaptcha: this.recaptcha },
        success: function() {
          this.$emit("close")
          this.$toasted.show("You are logged in.")
          EventBus.$emit("auth:login")
          this.loading = false
          this.$refs.recaptcha.reset()
        },
        error: function(data) {
          if (data.response && data.response.status === 422) {
            this.form.onFail(data)
            this.$error.form()
          }else{
            this.$error.generic()
          }
          this.loading = false
          this.recaptcha = ''
          this.$refs.recaptcha.reset()
        },
        redirect: null,
        rememberMe: true
      })
    },
    catpchaResponse(response) {
      this.form.errors.clear('recaptcha')
      this.recaptcha = response
    },
    forgotPassword() {
      this.$emit("close")
      this.$router.push({ name: "password.email" })
    }
  }
}
</script>

<style>
</style>
